export enum TimeFormat {
  HOURS_DECIMAL = 'hours_decimal',
  HOURS_MINUTES = 'hours_minutes'
}